var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGetHelpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5834V15.5934",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3749C10.9831 12.0774 11.0634 11.7824 11.2287 11.5344C11.3941 11.2864 11.6355 11.0988 11.9167 10.9999C12.2612 10.8682 12.5705 10.6582 12.8201 10.3867C13.0698 10.1151 13.2529 9.78923 13.3552 9.43482C13.4575 9.08041 13.4762 8.70708 13.4097 8.34424C13.3432 7.9814 13.1934 7.63894 12.9721 7.34384C12.7507 7.04873 12.4639 6.80903 12.1342 6.6436C11.8045 6.47817 11.4409 6.39154 11.072 6.39051C10.7031 6.38949 10.339 6.47411 10.0084 6.6377C9.67779 6.8013 9.38965 7.03941 9.16669 7.33328",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGetHelpWhite);
export default __webpack_public_path__ + "static/media/Icon_GetHelp_White.b9f4dc149de9718db847d122362ed711.svg";
export { ForwardRef as ReactComponent };